// @flow
import type { SortDirection, SortType } from '../../../helpers/compare';

type SortOption = {
  direction: SortDirection,
  property: string,
  type?: SortType,
};

export type SortOptions = {
  [string]: SortOption,
};

export const defaultSortOption = 'price:asc';

const sortOptions = {
  'make:asc': {
    direction: 'asc',
    property: 'make',
  },
  'make:desc': {
    direction: 'desc',
    property: 'make',
  },
  'price:asc': {
    direction: 'asc',
    property: 'price',
    type: 'number',
  },
  'price:desc': {
    direction: 'desc',
    property: 'price',
    type: 'number',
  },
};

export const getDefaultSortOption = (): SortOption => ({
  type: 'string',
  ...sortOptions[defaultSortOption],
});

export default sortOptions;
